import React from 'react'
import PropTypes from 'prop-types'
import Parser from 'html-react-parser'

import lang from 'lang'
import { replace } from 'common/utils'
import Link from 'next/link'

import { urls } from 'common/routes'
import NotificationHoc from '../create-notification-hoc'

@NotificationHoc
export default class CourseCreatedNotification extends React.Component {
  static propTypes = {
    course: PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
    }),
  }

  render() {
    const { name, slug } = this.props.course

    return (
      <Link href={urls.courseDetails(slug)}>
        <a>
          <div>{Parser(replace(lang.notifications.events.course.insert, [name]))}</div>
        </a>
      </Link>
    )
  }
}
